export const notLessThan = (value: number, limitation: number) => {
	return value <= limitation ? limitation : value;
};
